import { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Login.module.scss";
import logo from "./../../assets/images/logo.png";

export default function Login() {
  const navigate = useNavigate();

  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");

  const LoginUser = async () => {
    navigate("/");
  };

  const HandleKeyDown = (e) => {
    if (e.key === "Enter") {
      LoginUser();
    }
  };

  return (
    <div className={styles.loginWrapper}>
      <div className={styles.loginBox}></div>
      <div className={styles.loginBox}>
        <div className={styles.logoWrapper}>
          <img src={logo} alt="logo" />
        </div>
        <h1>Zaloguj się</h1>
        <div className={styles.formWrapper}>
          <input
            placeholder="Login"
            type="text"
            value={login}
            onChange={(e) => setLogin(e.target.value)}
            onKeyDown={HandleKeyDown}
          />
          <input
            placeholder="Hasło"
            type="password"
            autoComplete="off"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={HandleKeyDown}
          />
        </div>
        <button className={styles.btn} onClick={LoginUser}>
          Zaloguj
        </button>
        <p className={styles.report}>
          <a href="mailto:mail@examle.com">
            Nie pamiętasz hasła? Wyślij zgłoszenie z prośbą o zresetowanie.
          </a>
        </p>
      </div>
    </div>
  );
}
